<template>
    <div>
        <!-- select  pizza  size -->
                                <h2 class="Select_size_title">{{get_local_string.string_100}}
                                    <span class="bolletsNode">3</span>
                                </h2>
                                <div class="size_buttons">
                                    <template v-for="(size, index_parent) in getbox_details.dough">
                                        <template v-for="(sin_size ,index) in size.data">
                                            <label class="size_btn  dough-size-price"
                                                :class="[`dough-${size.id}`,{'active':index==0} , {'activeFirst':index_parent==0} ]" :key="sin_size.id">
                                                <input @change="changeSize($event)" name="size_id"
                                                    v-model="sizeData.size_id" :value="sin_size.size_id"
                                                    class="radio_type_size select_size_btn call-sum-price"
                                                    :data-price="sin_size.price"
                                                    :data-class="`pizza_${sin_size.data.name}`"
                                                    :data-title="`${sin_size.data.name} / ${sin_size.data.weight}cm / ${sin_size.data.pieces} biter`"
                                                    type="radio">
                                                <span class="text_name">
                                                    <span class="char_size">{{sin_size.data.code}}</span>
                                                    <span class="small_text">{{sin_size.data.name}}</span>
                                                </span>
                                                <span
                                                    class="price_size">{{parseFloat(sin_size.price).toFixed(0)}}{{get_setting_app.payment.currency}}</span>
                                            </label>
                                        </template>
                                    </template>
                                </div>
    </div>
</template>
<script>
 import $ from 'jquery';
import { mapGetters } from 'vuex';
export default {
    name:'SizeBtnTil',
    props:['sizeData' ,  'getbox_details' , 'extra_sum'],
    computed:{
        ...mapGetters({
             get_setting_app:'get_setting_app',
             get_local_string:'get_local_string'
        })
    },
    methods:{
         // on change size from lg to md or sm products
            changeSize(event) {
                event.preventDefault();
                $('.dough-size-price').removeClass('active');
                // put class pizza class on img prod
                $('.image_prod img').attr('class', 'cleanstate');
                $('.image_prod img').addClass($(event.target).attr('data-class'));
                // change title prod on change size 
                $('.size_item').text($(event.target).attr('data-title'));
                // ### change Price Total
                this.sizeData.price = (this.sizeData.qty * $(event.target).attr('data-price') + parseFloat(this.extra_sum));
                $(event.target).parent('.dough-size-price').addClass('active');
            },
    }
    }
</script>


<style lang="scss" scoped>
 .mb-100 {
        margin-bottom: 100px;
    }
       .Select_size_title {
        font-size: 14px;
        font-family: "Montserrat", sans-serif;
        font-weight: 600;
       color: black;
        margin-top: 25px;
    }

    .bolletsNode {
        border-radius: 500%;
        background: var(--active_color);
       color: black;
        height: 30px;
        width: 30px;
        transition: all 500ms ease-in-out;
        text-align: center;
        line-height: 30px;
        margin-left: -25px;
        position: absolute;
        left: 0px;
        margin-top: -8px;
    }

  .size_buttons {
            display: flex;
            font-family: "Montserrat", sans-serif;
            justify-content: flex-start;
            border: 1px solid var(--active_color);
            padding: 8px 10px;
            border-radius: 10px;
            margin-top: 10px;
            overflow-y: auto;
        }

        .size_btn {
            flex-direction: column;
            align-items: center;
            text-align: center;
            transition: 0.4s ease-in-out;
            margin-right: 20px;
            font-family: "Montserrat", sans-serif;
            position: relative;
            cursor: pointer;

            input {
                display: none;
            }

            .text_name {
                display: flex;
                flex-direction: column;
                text-align: center;
                width: 70px;
                height: 70px;
                color: #929292;
                justify-content: center;
                border-radius: 100%;
                font-size: 14px;
                border: 1px solid #929292;
                transition: 0.4s ease-in-out;

                .char_size {
                    font-weight: 900;
                    font-size: 15px;
                }

                .small_text {
                    font-size: 12px;
                    line-height: 12px;
                    font-weight: 600;
                }
            }

            .price_size {
                margin-top: 4px;
                font-size: 18px;
                font-weight: 800;
                color: #929292;
            }

        }
          .size_btn {
        display: none;
    }

    .size_btn.activeFirst {
        display: inline-flex;
    }

    .size_btn.active {
        color: var(--active_color) !important;
        transition: 0.4s ease-in-out;
        .char_size , .small_text{
         color: black;
        }
    }

    .size_btn.active .text_name {
        color: #fff !important;
        border: 1px solid var(--active_color);
        transition: 0.4s ease-in-out;
        background-color: var(--active_color);;
    }

    .size_btn.active .price_size {
        color: black;
        transition: 0.4s ease-in-out;
    }

    // end size
</style>